class EquipamentoFiscalizacao {
    constructor(
        {
            id = null,
            cod_equipamento = null,
            marca_modelo = null,
            ind_ativo = null,
            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,
            tipo_fiscalizacao = [],

        } = {}
    ) {
        this.id = id;
        this.cod_equipamento = cod_equipamento;
        this.marca_modelo = marca_modelo;
        this.ind_ativo = ind_ativo;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        this.usuario_id = usuario_id;
        this.tipo_fiscalizacao = tipo_fiscalizacao;
    }
}

export default EquipamentoFiscalizacao;